"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var base_1 = require("../../../themes/base");
var heightPerState = {
    entering: 3,
    entered: 3,
    exiting: 0,
    exited: 0,
    unmounted: 0
};
var OrangeBar = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  background: ", ";\n  width: 100%;\n  transition: height ", "ms ease-in-out;\n  ", "\n"], ["\n  position: absolute;\n  bottom: 0;\n  background: ", ";\n  width: 100%;\n  transition: height ", "ms ease-in-out;\n  ", "\n"])), base_1.colors.brandOrange, base_1.base.global.transition.durationMS, function (_a) {
    var state = _a.state;
    return "height: " + heightPerState[state] + "px;";
});
exports.default = OrangeBar;
var templateObject_1;
//# sourceMappingURL=OrangeBar.js.map